import { render, staticRenderFns } from "./SingleAuthorizationCode.vue?vue&type=template&id=a1b2cc38&scoped=true&"
import script from "./SingleAuthorizationCode.vue?vue&type=script&lang=js&"
export * from "./SingleAuthorizationCode.vue?vue&type=script&lang=js&"
import style0 from "./SingleAuthorizationCode.vue?vue&type=style&index=0&id=a1b2cc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b2cc38",
  null
  
)

export default component.exports